const o=e=>Math.ceil(e*60),t=e=>Math.ceil(e/60);export{o as convertMinutesToSeconds,t as convertSecondsToMinutes};
//# sourceMappingURL=duration.helpers.js.map
